// types
import { type ModuleType as Profile } from "./_definitions"
import { type State } from "../../types"

export const profileSelector = (state: State): Profile => state.profile
